export const PADDING = 15
export const TILE_MAX_WIDTH = 400
export const TILE_MARGIN_RIGHT = 7
export const TILE_GRID_PADDING = 7
